/**
파일명: MainLayout.jsx
설명: 헤더/본문/푸터 공통 프레임을 구성하는 레이아웃 컴포넌트입니다.
*/

import Footer from '../components/common/Footer';
import Header from '../components/common/Header';

export default function MainLayout({ pathname, onNavigate, children, hideChrome = false }) {
  // [비즈니스] 모든 페이지에서 동일한 브랜드 프레임을 유지해 UX 일관성을 확보합니다.
  // [기능] 헤더와 푸터를 고정 배치하고 중앙 본문에 페이지 콘텐츠(children)를 렌더링합니다.
  //        hideChrome이 true면 헤더/푸터를 생략하고 본문만 렌더링합니다.
  // [비즈니스] 관리자 콘솔처럼 공개 내비게이션이 필요 없는 화면에서 hideChrome을 사용합니다.
  // [기술] 헤더는 position:fixed이고 상단 여백은 각 페이지의 PageHero가 만듭니다.
  //        히어로가 없는 화면에서 헤더를 그대로 두면 콘텐츠가 헤더 아래에 가려지고,
  //        스크롤 최상단에서는 헤더가 투명이라 흰 배경 위 흰 글자가 됩니다.
  if (hideChrome) {
    return (
      <div className="site-shell">
        <main>{children}</main>
      </div>
    );
  }

  return (
    <div className="site-shell">
      <Header pathname={pathname} onNavigate={onNavigate} />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
